module.exports = __webpack_public_path__ + "static/img/mothersday-image-desktop.9ab6d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mothersday-image-desktop.jpg
// module id = 125
// module chunks = 0